import ImageCarouselBlock from './ImageCarouselBlock';

export default ImageCarouselBlock;
